import { ServiceDetail } from './base-api/types';
import { log } from './utils';

/**
 * Parses the response from itsServices.api and logs errors.
 * Returns the data if OK, otherwise null.
 */
function parseApiResponse<T>(res: {
  data?: T;
  meta?: { status: string };
}): T | null {
  if (!res || res.meta?.status === 'error') {
    log.error('API error', res);
    return null;
  }
  return res.data ?? null;
}

export type ServiceContentById = NonNullable<
  Awaited<ReturnType<typeof getServiceContentById>>
>;

export const getServiceContentById = async () => {
  const res = await window.itsServices.api.getServices();
  const data = parseApiResponse(res);

  if (!data?.services?.length) {
    return null;
  }

  const servicesRecord = data.services.reduce<Record<string, ServiceDetail>>(
    (acc, service) => {
      acc[service.id] = service;
      return acc;
    },
    {},
  );

  return servicesRecord;
};

export const getServicesByVariantId = async (variant_id: number) => {
  const res = await window.itsServices.api.getServiceOfferingsByVariantId({
    variant_id,
  });
  const data = parseApiResponse(res);

  if (!data?.services?.length) {
    return null;
  }

  return data.services;
};

export const getServicesByCartId = async (cart_id: string) => {
  const res = await window.itsServices.api.getServiceOfferingsByCartId({
    cart_id,
  });
  const data = parseApiResponse(res);

  if (!data?.cart_offerings?.items?.length) {
    return null;
  }

  return data.cart_offerings.items;
};

export const syncCartByCartId = async (cart_id = window.itsServices.cartId) => {
  const res = await window.itsServices.api.syncCartById({ cart_id });
  const data = parseApiResponse(res);

  if (!data) {
    return null;
  }

  return data;
};
